/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSessionTranscriptResult } from '../../models/get-session-transcript-result';

export interface ApiSessionsSessionIdTranscriptGet$Params {

/**
 * Session to read. Access is decided by the caller's own token.
 */
  sessionId: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiSessionsSessionIdTranscriptGet(http: HttpClient, rootUrl: string, params: ApiSessionsSessionIdTranscriptGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSessionTranscriptResult>> {
  const rb = new RequestBuilder(rootUrl, apiSessionsSessionIdTranscriptGet.PATH, 'get');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSessionTranscriptResult>;
    })
  );
}

apiSessionsSessionIdTranscriptGet.PATH = '/api/Sessions/{sessionId}/transcript';
